import { mount } from '../dom-lifecycle';
import { setRecaptchaResponse } from './recaptcha';
import { scrollToFirstError } from './validation';

async function handleAjaxFormSubmit(event) {
	event.preventDefault();
	const form = this;
	
	toggleSubmitButtons(form, false);
	await setRecaptchaResponse(form);

	try {
		var xhr = submitFormData(form);
		var data = await xhr;
	} catch (xhr) {
		return handleSubmitError(form, xhr);
	} finally {
		toggleSubmitButtons(form, true);
	}
	handleSubmitSuccess(form, data, xhr);
}

mount('.ajax-form', form => $(form).on('submit', handleAjaxFormSubmit));

function submitFormData(form) {
	return $.ajax({
		type: 'post',
		url: form.action,
		data: new FormData(form),
		processData: false,
		contentType: false,
		headers: {'X-Requested-With': 'XMLHttpRequest'}
	});
}

function handleSubmitSuccess(form, data, xhr) {
	const successEvent = $.Event('submit-success');
	successEvent.assert = assertResponse;
	$(form).trigger(successEvent, [data, xhr]);
	
	if (successEvent.isDefaultPrevented()) {
		return;
	}
	
	form.reset();
	if (data.redirect) {
		location.href = data.redirect;
	}
}

function handleSubmitError(form, xhr) {
	const errorEvent = $.Event('submit-error');
	$(form).trigger(errorEvent, xhr);
	
	if (errorEvent.isDefaultPrevented()) {
		return;
	}
	
	if (xhr.responseJSON?.formErrors) {
		processFormErrors(xhr.responseJSON.formErrors, form);
	} else if (xhr.responseJSON?.errors) {
		xhr.responseJSON?.errors.forEach(error => alert(error));
	} else {
		alert("Wystąpił nieznany błąd, spróbuj ponownie później.");
	}
	
	scrollToFirstError(form);
}

function toggleSubmitButtons(form, enabled) {
	$(form.elements).filter('[type=submit]').prop('disabled', !enabled);
}

export function processFormErrors(errors, form) {
	for (const fieldName in errors) {
		if (fieldName === form.name) {
			for (const error of errors[fieldName]) {
				alert(error);
			}
		} else {
			const field = form.elements[fieldName];
			if (!field) {
				continue;
			}
			const errorHtml = errors[fieldName].join('<br>');
			$(field).ajaxInvalidFeedback({ error: errorHtml });
		}
	}
}

export function assertResponse(condition) {
	if (condition) {
		return;
	}
	const message = 'Nieoczekiwana odpowiedź serwera. Odśwież stronę i spróbuj ponownie.';
	alert(message);
	throw new Error(message);
}